module.exports = __webpack_public_path__ + "media/images/pic/hero/hero-f209ccdfae7c6b41fec279c133256f16.svg";